import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import '../css/pages_styles.css';
import backgroundImage from '../assets/background.png';

const Wasn_papers = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: isMobile ? '0' : (sidebarExpanded ? '250px' : '0')
                }}
            >
                <div className="container">
                    <header 
                        className="header"
                        style={{backgroundImage: `url(${backgroundImage})`}}
                    >
                        <h1 className="title">WASN 論文</h1>
                    </header>
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <h2 className="subtitle">論文徵稿主題</h2>
                        <ul className="list">
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>AI Technologies in IoT, MANET, WAN, and WSN</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Big Data Analysis, Management, and Storage</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Cyber-Physical Systems (CPS)</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Emerging Applications of IoT</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Location Management</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Mobile Computing Applications</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Mobile Healthcare, Mobile Sensing</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Mobile Social Networks</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Performance Analysis of Wireless Systems</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Pervasive and Ubiquitous Computing</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Security and Privacy</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Smart Home, Smart City, Smart Factory, Smart Living</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Unmanned Aerial Vehicles</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Wearable Technology</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Wireless Communication Protocol and Architecture</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>Wireless Sensor Networks</li>
                        </ul>
                    </section>
                    <Footer/>
                </div>
            </div>
        </div>
    );
};

export default Wasn_papers;